import { Component, OnInit, Inject, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { CommonService } from '../services/commom.service';
import { BackgroundDashboardService } from '../services/backgroundDashboard.service';

@Component({
    selector: 'app-service-dialog',
    templateUrl: './selectedServiceDialog.component.html',
})
export class SelectedServiceDialogComponent implements OnInit {
    public SelectedServices = [];
    public Name = '';
    public IsAddedServices = false;
    public TotalCost = 0;
    public Email = '';
    public IsGlobalWatchList = false;
    constructor(public dialogRef: MatDialogRef<SelectedServiceDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: string, public vcRef: ViewContainerRef,
        private _Router: Router, private _CommonService: CommonService, private _BackgroundDashboardService: BackgroundDashboardService) {

        this.CheckDailguePageIsAdditionService();
        dialogRef.disableClose = true;
        this.Email = localStorage.getItem('Email');
        localStorage.setItem("IsAdditionalInfo", "No")
    }

    ngOnInit() { }

    OrderConfirmationEmail(SelectedServices) {
        if (localStorage.getItem('Email') !== null && localStorage.getItem('IsOrderConfirmationMailSent') === 'true') {
            this._BackgroundDashboardService.OrderConfirmationEmail(SelectedServices).
                subscribe(res => this.OrderConfirmationEmailSuccess(res), res => this.OrderConfirmationEmailError(res));
        }
    }

    OrderConfirmationEmailSuccess(res) {
        localStorage.setItem('IsOrderConfirmationMailSent', 'false');

    }

    OrderConfirmationEmailError(res) { }


    CheckDailguePageIsAdditionService() {
        debugger
        let ConfirmPackageDetails = [];
        this.IsGlobalWatchList = false;
        this.SelectedServices = [];
        this.Name = localStorage.getItem('FullNameOfUser');
        if (this._CommonService.IsNewServicesAddInPackage === false) {

            const data = localStorage.getItem('OrderSummaryDetails');
            this.SelectedServices = JSON.parse(data);
            ConfirmPackageDetails.push({ "PackageName": this.SelectedServices[0].PackageName })
            ConfirmPackageDetails = ConfirmPackageDetails.map(x => ({ ...x, ServiceCost: this.SelectedServices[0].PackageCost, "Services": this.SelectedServices[0].Services }));

        } else {
            this.IsAddedServices = true;
            this.SelectedServices = JSON.parse(localStorage.getItem('NewOrderProcessingService'));
            this.TotalCost = this.SelectedServices.map(res => res.ServiceCost)
                .reduce((a, b) => a + b);
            this.TotalCost = Number(this.TotalCost.toFixed(2));
            if (this.SelectedServices.length == 1) {
                let GlobalWatchList = this.SelectedServices.filter(x => x.ServiceMasterId == 86)
                if (GlobalWatchList.length > 0) {
                    this.IsGlobalWatchList = true;
                }
            }
            ConfirmPackageDetails.push({ "Services": this.SelectedServices })
            ConfirmPackageDetails = ConfirmPackageDetails.map(x => ({ ...x, TotalCost: this.TotalCost.toString() }));



        }
        ConfirmPackageDetails = ConfirmPackageDetails.map(x => ({
            ...x,
            'EmailId': localStorage.getItem('Email')
        }));

        this.OrderConfirmationEmail(ConfirmPackageDetails)
        this._CommonService.IsNewServicesAddInPackage = false
    }

    onNoClick(): void {
        this.dialogRef.close();
        this._Router.routeReuseStrategy.shouldReuseRoute = function () {
            return false;
        };

    }

    GoToDisclosure() {
        this.dialogRef.close();
        this._Router.navigate(['/background-login/signature']);
    }

    CompletedYourInformation() {
        this.dialogRef.close();
        var IsResumePendingCheck = this._CommonService.IsPackageContainEmployerEducationAndProfessionService(this.SelectedServices);
        if (IsResumePendingCheck == true) {
            return;
        }
        var IsCriminalPendingCheck = this._CommonService.IsPackageContainCriminalCheckService(this.SelectedServices);
        if (IsCriminalPendingCheck == true) {
            return
        }
    }
}
